







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import FileParseSubmittedFiles from '../components/file-parsing/file-parse-submitted-files.vue';

@Component({
  components: {
    PageTitle,
    FileParseSubmittedFiles
  }
})
export default class SubmittedFiles extends Vue {}
